var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-toolbar',{staticClass:"it-edit-toolbar transparent elevation-0",class:{ dark: false },attrs:{"dense":""}},[_c('toolbar',{attrs:{"editor":_vm.editor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }